import React from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles/projectCards.css';

const ProjectCards = ({ projects }) => {
    const props = useSpring({ opacity: 1, from: { opacity: 0 }, config: { duration: 500 } });

    return (
        <div className="project-grid">
            {projects.map((project) => (
                <div key={project.id} className="project-card">
                    <h3>
                        <a href={project.url} target="_blank" rel="noopener noreferrer">
                            {project.name}
                        </a>
                    </h3>
                    <p>{project.description}</p>
                    <div className="project-tags">
                        {project.tags && project.tags.map((tag) => (
                            <span key={tag} className="project-tag">{tag}</span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ProjectCards;
